import React, { FC } from "react";
import { makeStyles, Box, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import colors from "../constants/colors";

interface INavLinkProps {
  to: string;
  close: () => void;
  children?: React.ReactNode;
}

export const NavLink: FC<INavLinkProps> = ({ close, to, children }) => {
  const classes = styles();
  return (
    <Box className={classes.container} onClick={close}>
      <Link className={classes.link} to={to}>
        <Typography>{children}</Typography>
      </Link>
    </Box>
  );
};

const styles = makeStyles(({ typography }) => ({
  container: {
    marginBottom: 10,
  },
  link: {
    textDecoration: "none",
    color: colors.secondary,
    "&:hover": {
      color: colors.primary,
    },
  },
}));
